(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.paragraph_hero = {
    attach: function (context, settings) {
      $(once('height', '.paragraph--hero.paragraph--view-mode--content_aside .hero__images')).matchHeight({
        target: $('.paragraph--hero.paragraph--view-mode--content_aside .hero__content')
      });

      $(once('slick', '.hero__images .hero__images__inner')).slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        lazyLoad: 'progressive'
      });
    }
  };

})(jQuery, Drupal);
